import { render } from "./sipTemplate.vue?vue&type=template&id=4652ea10&scoped=true"
import script from "./sipTemplate.vue?vue&type=script&lang=js"
export * from "./sipTemplate.vue?vue&type=script&lang=js"

import "./sipTemplate.vue?vue&type=style&index=0&id=4652ea10&scoped=true&lang=css"
import "./sipTemplate.vue?vue&type=style&index=1&id=4652ea10&lang=css"
script.render = render
script.__scopeId = "data-v-4652ea10"

export default script